<template>
    <div class="col-12 col-md-9 col-lg-6 col-lg-offset-1">
        <div class="content source-medium">
            <div class="h5 title">{{ $t('views.dashboard.sections.analytics_source_medium.title') }}</div>
            <div class="p description">{{ $t('views.dashboard.sections.analytics_source_medium.description') }}</div>
            <LoadingSection v-if="loading" :showMessage="false" />
            <template v-else>
                <h6 v-if="mediums.length > 0" class="stat-group-title">{{ $t('views.dashboard.sections.analytics_source_medium.medium_label') }}</h6>
                <ul v-if="mediums.length > 0" class="stats">
                    <li class="stat" v-for="(m, i) in mediums" :key="'medium-' + i">
                        <div class="name">{{ m.name }}</div>
                        <div class="value">{{ m.count }}</div>
                    </li>
                </ul>
                <h6 v-if="sources.length > 0" class="stat-group-title">{{ $t('views.dashboard.sections.analytics_source_medium.source_label') }}</h6>
                <ul v-if="sources.length > 0" class="stats">
                    <li class="stat" v-for="(s, i) in sources" :key="'source-' + i">
                        <div class="name">{{ s.name }}</div>
                        <div class="value">{{ s.count }}</div>
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import { formatNumber } from '@/utils/formatting';
    import LoadingSection from '@/components/sections/LoadingSection';

    export default {
        name: "DashboardSourceMedium",
        components: {
            LoadingSection
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(useAccountStore, ['hasAccountStats', 'accountStats']),
            sources() {
                const source = this.accountStats?.source;
                if (!this.hasAccountStats || typeof source !== 'object' || !source) return [];
                
                const blacklist = ['undefined', 'null'];
                
                return Object.entries(source)
                    .filter(([name]) => {
                        const sourceName = String(name || '').toLowerCase();
                        return sourceName && !blacklist.some(term => sourceName.includes(term));
                    })
                    .sort((a, b) => (b[1] ?? 0) - (a[1] ?? 0))
                    .slice(0, 10)
                    .map(([name, count]) => ({ 
                        name: String(name), 
                        count: this.formatNumber(count ?? 0) 
                    }));
            },
            mediums() {
                const medium = this.accountStats?.medium;
                if (!this.hasAccountStats || typeof medium !== 'object' || !medium) return [];
                
                const blacklist = ['undefined', 'null'];
                
                return Object.entries(medium)
                    .filter(([name]) => {
                        const mediumName = String(name || '').toLowerCase();
                        return mediumName && !blacklist.some(term => mediumName.includes(term));
                    })
                    .sort((a, b) => (b[1] ?? 0) - (a[1] ?? 0))
                    .slice(0, 10)
                    .map(([name, count]) => ({ 
                        name: String(name), 
                        count: this.formatNumber(count ?? 0) 
                    }));
            }
        },
        methods: {
            formatNumber
        }
    }
</script>